import { describeTarget } from './naming.ts'
import { describeContext } from './context.ts'
import type { LoggableEvent } from '../recorder.ts'

export interface PointerOptions {
  document: Document
  log: (event: LoggableEvent) => void
  /** How long the pointer must stay on an element before it counts as pointing at it. */
  restMs?: number
}

const IGNORE_SELECTOR = '[data-sat-ignore]'
const DEFAULT_REST_MS = 600

/** Logs where the pointer rests: the element it points at (named from the allowlist) and its position. */
export function startPointer({ document, log, restMs = DEFAULT_REST_MS }: PointerOptions): () => void {
  let timer: ReturnType<typeof setTimeout> | undefined
  let lastLogged: Element | null = null

  const onMove = (event: Event) => {
    clearTimeout(timer)
    const target = event.target
    if (!(target instanceof Element) || target.closest(IGNORE_SELECTOR)) return
    const { clientX, clientY } = event as MouseEvent
    timer = setTimeout(() => {
      if (target === lastLogged) return
      lastLogged = target
      const { name, role } = describeTarget(target)
      log({ type: 'pointer', name, role, restMs, x: Math.round(clientX), y: Math.round(clientY), ...describeContext(target) })
    }, restMs)
  }

  document.addEventListener('pointermove', onMove, true)
  return () => {
    clearTimeout(timer)
    document.removeEventListener('pointermove', onMove, true)
  }
}
